/**
 * @file 封装请求数据接口
 * @author quda
 */
import jsonp from '@/common/utils/jsonp.js';
import Const from './constant/Constant';
import {getParamsFromUrl} from '@baidu/map-fe-utils';

export default (url, reqParams = {}, option) => {
    if (!url) {
        throw new Error('[Error] request url is required!');
    }
    // 接口path
    let addressUrl = Const.dataUrl[url];
    if (addressUrl && addressUrl.isMock === 1) {
        const mockData = require('./mocks/index');
        let data = mockData.default[url];
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject({
                        errno: -3,
                        errmsg: '[ERROR] Time out.',
                        data: {}
                    });
                }
            }, 50);
        });
    }
    const urlParams = getParamsFromUrl();
    // 接入昊天镜参数
    const params = {
        cuid: window.yymap.nativeAppAdapter.phoneinfo.cuid || '',
        zid: window.yymap.nativeAppAdapter.phoneinfo.zid || '',
        fr: urlParams.fr || 'default',
        os: urlParams.os || window.yymap.nativeAppAdapter.phoneinfo.os || '',
        sv: urlParams.sv || window.yymap.nativeAppAdapter.phoneinfo.sv || '',
        to: window.xaf.getData().Token,
        vw: window.xaf.getData().view
    };
    Object.assign(reqParams, params);
    return jsonp(addressUrl.url, reqParams, option);

};
